module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-06-32c40cc791207b121b2b4e72d5736652.png";